import React, { useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

import TopBar from "components/dashboardParts/TopBar";
import { Query } from "system/query/Query";
import QueryDialog from "components/queries/QueryDialog";
import { defaultQuery } from "system/query/Query";
import QueryList from "./QueryList";

export default function QueryManagementPage(): React.JSX.Element {
  const { i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [showCreateQuery, setShowCreateQuery] = useState<boolean>(false);
  const [reloadCounter, setReloadCounter] = useState<number>(0);

  const starterQuery = new Query(defaultQuery);

  return (
    <Box sx={{ maxWidth: "1300px", margin: "0 auto", pl: 2, pr: 2, position: "relative" }}>
      <TopBar showLogo={true} title={i18n.t("query-management-page.title")} />
      <Box sx={{
        textAlign: "center"
      }}>
        <Button color="success" variant="contained" onClick={() => setShowCreateQuery(true)}>
          {i18n.t("query-management-page.create-query")}
        </Button>
      </Box>
      <Box sx={{
        marginTop: 1
      }}>
        <QueryList
          canEditQuery={true}
          enableMultiEditing={true}
          onReload={() => {
            window.location.reload();
          }}
          reloadCounter={reloadCounter}
          showCopyButton={true}
          showDeleteButton={true}
          showLoadButton={true}
          showSelectMultipleToggle={true}
          showShareButton={true}
        />
      </Box>
      {showCreateQuery &&
        <QueryDialog
          isOpen={true}
          query={starterQuery}
          onClose={() => {
            setShowCreateQuery(false);
          }}
          onSubmit={() => {
            setShowCreateQuery(false);
            setReloadCounter((value) => value+1);
            enqueueSnackbar(i18n.t("query-management-page.save-success"), { variant: "success" })
          }} 
        />
      }
    </Box>
  );
}
